import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "single-column-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.75 5C6.75 3.48122 7.98122 2.25 9.5 2.25H14.5C16.0188 2.25 17.25 3.48122 17.25 5V19C17.25 20.5188 16.0188 21.75 14.5 21.75H9.5C7.98122 21.75 6.75 20.5188 6.75 19V5ZM9.5 3.75C8.80964 3.75 8.25 4.30964 8.25 5V19C8.25 19.6904 8.80964 20.25 9.5 20.25H14.5C15.1904 20.25 15.75 19.6904 15.75 19V5C15.75 4.30964 15.1904 3.75 14.5 3.75H9.5Z"
    }, null, -1)
  ])))
}
export default { render: render }